<template>
  <div class="col-sm-6 col-md-4 col-lg-3">
    <sikanii-select
      v-if="isAdmin"
      v-model="agentId"
      class="mt-25"
      label-name="full_name"
      value-name="id"
      name="agent"
      placeholder="Filter by Agent"
      :options="agents"
    />
  </div>
</template>
<script>
import SikaniiSelect from '@/layouts/components/SikaniiSelect.vue'

export default {
  name: 'AgentFilter',
  components: { SikaniiSelect },
  data() {
    return {
      agentId: null,
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/role'] === 'Administrator'
    },
    agents() {
      return this.$store.getters['userAccounts/agents']
    },
  },
  watch: {
    agentId(id) {
      this.$emit('filter', id)
    },
  },
  mounted() {
    this.getAgents()
  },
  methods: {
    getAgents() {
      if (this.agents.length > 0) {
        return
      }
      this.$http.get('user-accounts/agents')
        .then(res => {
          this.$store.commit('userAccounts/setAgents', res.data)
        })
    },
  },
}
</script>

<style scoped>

</style>
